import { useMate } from "../mate";
import ModuleBase from "./moduleBase";
import {
  Mate,
  MateModule,
  ModuleEntityType,
  ModuleQuestion,
  Worldview,
} from "@/types/entity";
import ModuleBaseImpl from "./moduleBaseImpl";
import { showConfirmDialog, showLoadingToast, showSuccessToast } from "vant";
import i18n from "@/locales";
import { HOME_ROUTER } from "@/use/go";

export const BASIC_INFO_MODULE_ID = 1; // 基本信息
export const TONE_MODULE_ID = -2; // 音色设定
export const SPRITE_MODULE_ID = -3; // OC 演绎
export const FEATURE_MODULE_ID = -4; // 为Ta捏图
export const GALLERY_MODULE_ID = 336; // 稿件
export const STORY_MODULE_ID = -6; // 故事集
export const MOMENT_MODULE_ID = -7; // 星辰日志
export const TASK_MODULE_ID = -8; // 生图队列
export const CHAT_MODULE_ID = -10; // 聊天
// export const ADMIRE_MODULE_ID = -11; // 点赞
// export const CHAT_PROMPT_MODULE_ID = -12; // 聊天提示词
// export const SUBSCRIPTION_MODULE_ID = -13; // 订阅
// export const CHAT_EMOTION_MODULE_ID = -14; // 聊天表情
// export const CHAT_SAMPLE_MODULE_ID = -15; // 聊天样本
// export const CHAT_IMAGE_MODULE_ID = -16; // 自拍
// export const CHAT_SCENE_MODULE_ID = -17; // 场景
// export const CHAT_PERSONA_MODULE_ID = -18; // 人格注入
export const COLLECTION_MODULE_ID = -19; // 设定合集
export const GAL_GAME_MODULE_ID = -20; // 视觉小说
export const CHAT_LIST_MODULE_ID = -21; // 与OC对话
export const APPEARANCE_MODULE_ID = 215; // 外貌特征
export const POWER_MODULE_ID = 216; // 能力设定
export const BG_STORY_MODULE_ID = 217; // 背景故事
export const RELATION_MODULE_ID = 218; // 人际关系
export const TIMELINE_MODULE_ID = 368; // 时间线
export const PERSONA_MODULE_ID = 1377; // 形象
class ModuleMate extends ModuleBase implements ModuleBaseImpl {
  constructor(
    entity: Mate | Worldview,
    entityType: ModuleEntityType,
    mateModuleList: MateModule[],
    moduleQuestionMap: Record<number, ModuleQuestion[]>
  ) {
    super(entity, entityType, mateModuleList, moduleQuestionMap);

    this.initMateModuleOrder();
    this.initModuleList();
  }

  canEditModule(moduleId: number): boolean {
    return !this.moduleIdMap[moduleId].isPreset;
  }

  canDeleteModule(moduleId: number): boolean {
    if (moduleId === POWER_MODULE_ID) return true;

    return !this.moduleIdMap[moduleId].isPreset;
  }

  canExportModule(moduleId: number): boolean {
    if (moduleId === POWER_MODULE_ID) return true;

    return !this.moduleIdMap[moduleId].isPreset;
  }

  async updateEntityOrder(): Promise<void> {
    if (!useMate().isMyMate(this.entity.uuid)) return;
    this.entity.moduleOrder = this.entity.moduleOrder.filter(
      (v) => v.id !== undefined
    );
    await useMate().updateMateDetail(this.entity.uuid, {
      moduleOrder: this.entity.moduleOrder,
    });
    return;
  }

  async publish(): Promise<void> {
    await useMate().publish(this.entity.uuid);
  }

  async deleteEntity(): Promise<void> {
    try {
      await showConfirmDialog({
        title: i18n.global.t("ConfirmModal.deleteMateTitle"),
        message: i18n.global.t("ConfirmModal.deleteMateInfo"),
        confirmButtonText: i18n.global.t("Buttons.confirm"),
        cancelButtonText: i18n.global.t("Buttons.cancel"),
      });
    } catch {
      return;
    }
    const toast = showLoadingToast({
      message: i18n.global.t("Message.deletingCharacter"),
      duration: 0,
    });
    try {
      await useMate().deleteCurrentMate(this.entity as Mate);
      toast.close();
      showSuccessToast(i18n.global.t(`Message.deleteSuccessful`));
      await new Promise((r) => setTimeout(r, 1000));
      window.$router.replace(HOME_ROUTER);
    } catch (e) {
      toast.close();
    }
  }
}

export default ModuleMate;
